<template>
    <v-dialog v-model="dialog" width="fit-content">
        <template v-slot:activator="scope">
            <slot name="activator" v-bind="scope">
                <v-card width="fit-content" v-bind="scope.attrs" v-on="scope.on">
                    <Qr :url="url" :size="200" />
                </v-card>
            </slot>
        </template>
        <v-card>
            <Qr :url="url" :size="isPhoneBool ? 320 : 400" />
            <v-row no-gutters>
                <a :href="url" class="mb-4 mx-auto" style="max-width: 320px;">{{ url }}</a>
            </v-row>
        </v-card>
    </v-dialog>
</template>


<script>
import Qr from "@/components/SingleUse/Qr.vue";

export default {
    name: 'QrDialog',
    props: {
        trigger: Number,
        url: String,
    },
    components: {
        Qr,
    },

    data() {
        return {
            dialog: false,
        };
    },

    mounted() {
    },

    methods: {
    },

    computed: {},

    watch: {
        trigger: function () {
            this.dialog = true;
        }
    },
};
</script>


<style lang='scss' scoped></style>